import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
import { useStore } from 'src/stores';
import { getCurrentCompanyId } from 'src/stores/billAutomation/currentCompanyId';
import { monthKeyOf } from './monthKeys';

/**
 * The company's month in progress, as a month key (LB-6009): what tells a scheduled bill still waiting for its month
 * from one whose month has opened. Read once per company, never from a store another company left behind; null while
 * it is being read or when it can't be, and the page then says only which month a bill is scheduled for.
 *
 * One reader per page (the Bills tab), handing it down: the store's read cancels one still in flight, so a second
 * reader would cancel the first.
 */
export const useMonthInProgress = () => {
  const store = useStore();
  const companyId = getCurrentCompanyId();
  const _useState = useState({
      companyId: null,
      key: null
    }),
    _useState2 = _slicedToArray(_useState, 2),
    known = _useState2[0],
    setKnown = _useState2[1];
  useEffect(() => {
    if (!companyId || known.companyId === companyId) return undefined;
    let cancelled = false;
    (async (_store$allocations, _resp$response, _resp$response2) => {
      const resp = await ((_store$allocations = store.allocations) === null || _store$allocations === void 0 || (_store$allocations = _store$allocations.getMonthInProgressAsync) === null || _store$allocations === void 0 ? void 0 : _store$allocations.run({
        companyId
      }));
      if (cancelled) return;
      const key = monthKeyOf(resp === null || resp === void 0 || (_resp$response = resp.response) === null || _resp$response === void 0 ? void 0 : _resp$response.year, resp === null || resp === void 0 || (_resp$response2 = resp.response) === null || _resp$response2 === void 0 ? void 0 : _resp$response2.month);
      // No answer (cancelled, or the read failed) is not an answer: nothing is kept, so it is read again next time.
      if (key !== null) setKnown({
        companyId,
        key
      });
    })();
    return () => {
      cancelled = true;
    };
  }, [companyId, known.companyId, store]);
  return known.companyId === companyId ? known.key : null;
};